import { Link } from "react-router";
import policies from "../../shared/legalPolicies.json";

export default function PolicyLinks({ newTab = false }) {
  return <nav aria-label="Legal policies" className="flex flex-wrap justify-center gap-x-4 gap-y-2 px-4 py-4 text-xs font-medium text-gray-600">
    {[["privacy", "Privacy Policy"], ["terms", "Terms and Conditions"], ["refunds", "Cancellation and Refunds"]].map(([slug, title]) =>
      <Link key={slug} to={`/policies/${slug}`} target={newTab ? "_blank" : undefined} rel={newTab ? "noopener noreferrer" : undefined} className="underline underline-offset-4 hover:text-orange-700">{title}{policies.policies.find(item => item.slug === slug)?.status === "published" ? "" : " (draft)"}</Link>)}
  </nav>;
}
